import { ServiceException } from '@inter-ikea-kompis/exceptions';

interface IBitboxContextResponseV1 {
	CookieConsent: {
		necessary: boolean;
		preferences: boolean;
		marketing: boolean;
		statistics: boolean;
	};
	PHPSESSID: string;
	SPCIITEM: string;
}

interface IBitboxContextResponseV2 extends IBitboxContextResponseV1 {
	/**
	 * Bearer token for use in Authorization header. Should always be set in
	 * responses from the v2 endpoint, but not in the v1 endpoint. Undefined type
	 * for type safety even when configured with the v1 endpoint in DEXF Settings.
	 */
	token: string;
}

type BitboxContextResponse = IBitboxContextResponseV1 | IBitboxContextResponseV2;

/**
 * Utilities related to BitBox.
 */
export default class BitBoxUtility {
	public static async readIframeContext(iframe: HTMLIFrameElement): Promise<BitboxContextResponse> {
		return await new Promise<BitboxContextResponse>((resolve, reject) => {
			const timeout = setTimeout(() => {
				window.removeEventListener('message', messageListener);
				reject(new ServiceException('No response from Bitbox iframe script'));
			}, 1000);

			const messageListener = (event: { data: string }): void => {
				let parsedData;
				try {
					parsedData = JSON.parse(event.data);
				} catch (error) {
					return;
				}
				if (parsedData.action === 'set_context') {
					window.removeEventListener('message', messageListener);
					clearTimeout(timeout);

					resolve(parsedData.value);
				}
			};

			window.addEventListener('message', messageListener);

			iframe.contentWindow?.postMessage(JSON.stringify({ action: 'get_context' }), '*');
		});
	}
}
